/*
 * Indexeddb is a object database in the browser
 * We use it to cache data for faster usage and for offline access
 *
 */

import Dexie from 'dexie';

let cookiesDb;

const createCookiedatabase = () => {
	// create cookie database and store
	cookiesDb = new Dexie('cookies');
	cookiesDb.version(1).stores({ cookies: 'name' });
	return cookiesDb;
};

export const getCookiedatabase = () => {
	if (cookiesDb && cookiesDb.isOpen()) return cookiesDb;
	return createCookiedatabase();
};

// General functions for an key value store
export const storeCookieIdb = async (name, value) => getCookiedatabase().cookies.put({ name, value });

export const getCookieIdb = async (name) => {
	const cookie = await getCookiedatabase().cookies.where('name').equals(name).first();
	return cookie?.value;
};

export const deleteCookieIdb = async (name) => getCookiedatabase().cookies.where('name').equals(name).delete();

// special functions for session token
export const getLocalToken = () => getCookieIdb('token');

export const storeTokenLocal = (token) => storeCookieIdb('token', token);

export const deleteTokenLocal = () => deleteCookieIdb('token');
